export const API_ROBOTS_PENDING = "API_ROBOTS_PENDING";
export const API_ROBOTS_SUCCESS = "API_ROBOTS_SUCCESS";
export const API_ROBOTS_FAILURE = "API_ROBOTS_FAILURE";
